module.exports = __webpack_public_path__ + "static/media/ho.79bc945e.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/ho.png
// module id = 791
// module chunks = 0